export function formatHeight(heightFeet?: number, heightInches?: number): string | undefined {
    if (heightFeet == null && heightInches == null) return undefined;

    const feetPart = heightFeet != null ? `${heightFeet}'` : '';
    const inchesPart = heightInches != null ? `${heightInches}"` : '';

    return `${feetPart}${inchesPart}`;
}
